import React, { useContext, useEffect, useRef, useState } from 'react';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';
import './PromotionalKitchenMenu.scss';
import AlertDialog from '../../atomic/Dialog/Dialog';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { StoreHeaderDataContext } from '../../context-api/StoreHeaderDataProvider';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { getUrlParams, getUrlPath } from '../../global/getUrl';
import { GlobalStateDataContext } from '../../context-api/GlobalStateDataProvider';
import { CheckoutDataContext } from '../../context-api/CheckoutDataProvider';
import VerticalAlwaysOpenStepper from '../../pages/nextdaypromotionmeal/VerticalSteps';
import { SpeedDial, SpeedDialIcon } from '@mui/material';
import AtomicButton from '../../atomic/button/AtomicButton';

const PromotionalKitchenMenu = (props) => {
  const { DisplayOnCart = false } = props;

  const { kitchensByZipcodeResponse } = useContext(StoreHeaderDataContext) || {};
  const { payAsYouGoPayloadForCheckout } = useContext(CheckoutDataContext);
  const KitchenNameToRedirect = payAsYouGoPayloadForCheckout?.kitchen_name;
  const {
    storeName,
    productsData,
    getProductList,
    sortedKitchenData,
    setSortedKitchenData,
    cartItems,
    totalPromotionalItemsInCart,
    totalItemsInCart,
    promotionalKitchenList,
    PromoSpendRequiredAmount,
    HowMuchMoreToSpend,
    PromoVerbage,
    flagToDisplayFreeItems,
    setFlagToDisplayFreeItems,
  } = useContext(OnTheMenuDataContext);
  const { OnLoadInformation, onLoadInfoResponse } = useContext(GlobalStateDataContext);
  const BranchPromoFlag =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.branchAgreedFreeComboPromoForPayAsYouGo;
  const { storename: urlStoreName } = getUrlParams();
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [showAgreeButton, setshowAgreeButton] = useState(true);
  const [showDisagreeButton, setshowDisagreeButton] = useState(false);
  const [buttonAgreeLabel, setButtonAgreeLabel] = useState('Okay');
  const drawerContainerRef = useRef();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const promoKtchenName = () =>
    kitchensByZipcodeResponse?.data?.promoKitchenNames?.[0] ||
    promotionalKitchenList?.[0]?.kitchenName;
  const PromoProductCount = productsData?.data?.data?.[promoKtchenName()]?.product_count === 0;
  const PromoProducts = PromoProductCount ? null : productsData?.data?.data?.[promoKtchenName()]; // Sorting kitchen information from /GetProduct API
  const DataKitchenInfo = productsData?.data?.data?.[KitchenNameToRedirect]; // Sorting kitchen information from /GetProduct API
  const PayAsYouGoCombo_Items = PromoProducts?.payasyougo_combo || [];
  const SubscriptionCombo_Items = PromoProducts?.subscription_combo || [];
  const CheckUrlCheckoutOrder = getUrlPath().includes('/checkoutorder');

  // console.log('-----PromoProducts 777', PromoProducts)
  // console.log('-----PayAsYouGoCombo_Items', PayAsYouGoCombo_Items)
  // console.log('-----SubscriptionCombo_Items', SubscriptionCombo_Items)
  // console.log('----promoKtchenName 888', promoKtchenName())
  // console.log('------urlStoreName 666', urlStoreName)
  // console.log('--------kitchensByZipcodeResponse', kitchensByZipcodeResponse)
  // console.log('-----sortedKitchenData', sortedKitchenData)
  // console.log('--productsData', productsData)
  // console.log('-----KitchenNameToRedirect', KitchenNameToRedirect)
  // console.log('-----flagToDisplayFreeItems', flagToDisplayFreeItems)

  const initfunc = async () => {
    if (isDesktop || isIpad) {
      setAlertOpen(true);
      // setFlagToDisplayFreeItems(isAlertOpen)
    }

    if (isMobile) {
      setIsDrawerOpen(true);
      // setFlagToDisplayFreeItems(isDrawerOpen)
    }

    if (PromoProducts === undefined) {
      await getProductList({
        kitchen_names: [
          CheckUrlCheckoutOrder ? KitchenNameToRedirect : urlStoreName,
          promoKtchenName(),
        ],
      });
      return;
    }
  };

  useEffect(() => {
    setFlagToDisplayFreeItems(isAlertOpen || isDrawerOpen);
  }, [isAlertOpen, isDrawerOpen]);

  useEffect(() => {
    if (CheckUrlCheckoutOrder && Object.keys(sortedKitchenData).length === 0) {
      // If you are adding anything to setSortedKitchenData pls add that code on  [ Pdp.jsx, StoreMenu.jsx, PromotionalKitchenMenu.js OntheMenuDataProvider.jsx ]
      if (productsData?.data?.data?.[KitchenNameToRedirect]?.product_count >= 1) {
        setSortedKitchenData({
          ...sortedKitchenData,
          kitchenName: DataKitchenInfo?.kitchenName,
          kitchen_id: DataKitchenInfo?._id,
          account_type: DataKitchenInfo?.account_type,
          display_name: DataKitchenInfo?.display_name,
          display_image: DataKitchenInfo?.display_image,
          cuisine: DataKitchenInfo?.cuisine,
          meal_offering: DataKitchenInfo?.meal_offering,
          operation_start_time: DataKitchenInfo?.operation_start_time,
          operation_end_time: DataKitchenInfo?.operation_end_time,
          opening_status: DataKitchenInfo?.opening_status,
          delivery_agreement_fees: DataKitchenInfo?.delivery_agreement_fees,
          address: DataKitchenInfo?.Geolocation?.formattedAddress,
          deliveryPayAsYouGo_fee: DataKitchenInfo?.deliveryPayAsYouGo_fee,
          deliverySubscription_fee: DataKitchenInfo?.deliverySubscription_fee,
          delivery_type_available: DataKitchenInfo?.delivery_type_available,
          freePayAsYouGoDelivery: DataKitchenInfo?.freePayAsYouGoDelivery,
          freePayAsYouGoDelivery_TimeGap: DataKitchenInfo?.freePayAsYouGoDelivery_TimeGap,
          freeSubscriptionDelivery: DataKitchenInfo?.freeSubscriptionDelivery,
          freeSubscriptionDelivery_TimeGap: DataKitchenInfo?.freeSubscriptionDelivery_TimeGap,
          nearestKitchenNames: DataKitchenInfo?.nearestKitchenNames,
          storeIsClosedForShortTime: DataKitchenInfo?.storeIsClosedForShortTime,
          agreedForFreeComboPromo: DataKitchenInfo?.agreedForFreeComboPromo,
          amountRequiredForComboPromo: DataKitchenInfo?.amountRequiredForComboPromo,
          subscriptionMenuAvailable: DataKitchenInfo?.subscriptionMenuAvailable,
          regularMenuAvailable: DataKitchenInfo?.regularMenuAvailable,
          status: DataKitchenInfo?.status,
          delivered_by: DataKitchenInfo?.delivered_by,
          delivery_kitchen_fee: DataKitchenInfo?.delivery_kitchen_fee,
          restrictedDeliveryDay: DataKitchenInfo?.restrictedDeliveryDay,
          restrictedDeliveryStartTime: DataKitchenInfo?.restrictedDeliveryStartTime,
          restrictedDeliveryEndTime: DataKitchenInfo?.restrictedDeliveryEndTime,
          delivery_driver_shortage: DataKitchenInfo?.delivery_driver_shortage,
          pickup_order_promotion: DataKitchenInfo?.pickup_order_promotion,
          Geolocation: DataKitchenInfo?.Geolocation,
          package_plan: DataKitchenInfo?.package_plan,
          dedicated_drivers: DataKitchenInfo?.dedicated_drivers,
        });
      }
    }
  }, [JSON.stringify(productsData)]);

  const onAlertAgree = () => {
    setAlertOpen(false);
  };

  const onAlertDisagree = () => {
    setAlertOpen(false);
  };

  if (isDrawerOpen) {
    return (
      <div className='drawerContainerPromoAlert' ref={drawerContainerRef}>
        <SwipeableDrawer
          anchor='bottom'
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
          onOpen={() => {
            setIsDrawerOpen(true);
          }}
          swipeAreaWidth={56}
          disableSwipeToOpen={false}
          ModalProps={{
            keepMounted: true,
          }}
          style={{ zIndex: 10005 }}
          container={drawerContainerRef.current}
        >
          <div style={{ height: '70vh' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                border: 'rgb(149, 237, 135)',
                backgroundColor: 'rgb(149, 237, 135)',
                height: isMobile ? '80px' : '70px',
                alignContent: 'center',
                justifyContent: 'center',
                padding: '5px 18px 0px 18px',
                color: 'rgb(0, 49, 92)',
                fontSize: isMobile ? '16px' : '18px',
                textAlign: 'center',
                fontFamily: 'Inter Medium',
              }}
            >
              <div>
                {PromoVerbage()} {'\u{1F60A}'}
              </div>
            </div>
            <VerticalAlwaysOpenStepper />
          </div>
        </SwipeableDrawer>
      </div>
    );
  }

  if (isMobile && !DisplayOnCart) {
    return (
      <>
        {!CheckUrlCheckoutOrder && (
          <>
            {totalItemsInCart !== 0 && (
              <SpeedDial
                ariaLabel='SpeedDial basic example'
                sx={{ position: 'fixed', bottom: 90, right: 16 }}
                icon={<SpeedDialIcon />}
                onClick={initfunc}
              ></SpeedDial>
            )}

            {totalItemsInCart === 0 && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 10001,
                  width: '100vw',
                  height: '100px',
                  color: 'rgb(0, 49, 92)',
                  fontSize: '18px',
                  border: '4px solid rgb(149, 237, 135)',
                  backgroundColor: 'rgb(149, 237, 135)',
                  borderRight: '0px',
                  borderLeft: '0px',
                  borderBottom: '0px',
                  borderRadius: '8px 8px 0px 0px',
                  position: 'fixed',
                  bottom: 0,
                  padding: '5px 20px 10px 20px',
                  textAlign: 'center',
                  fontFamily: 'Inter Medium',
                  fontSize: '15px',
                  letterSpacing: '0.5px',
                  lineHeight: '18px',
                }}
              >
                <div>
                  {PromoVerbage()} {'\u{1F60A}'}
                </div>

                <AtomicButton
                  label='NextDay Meal Menu'
                  style={{
                    height: '30px',
                    backgroundColor: `#181436`,
                    postion: 'relative',
                    fontSize: '14px',
                    width: '180px',
                    marginTop: '7px',
                    marginBottom: '1px',
                    letterSpacing: '0.5px',
                    border: 'none',
                  }}
                  handleSubmit={initfunc}
                  disabled={false}
                  endIcon={''}
                  startIcon={''}
                />
              </div>
            )}
          </>
        )}

        {CheckUrlCheckoutOrder && (
          <button
            style={{
              marginLeft: '10px',
              fontFamily: 'Roboto Medium',
              letterSpacing: '0.5px',
              fontSize: '11px',
              border: '0.5px solid rgb(24, 20, 54)',
              borderRadius: '3px',
              color: 'white',
              background: 'rgb(24, 20, 54)',
              height: '20px',
            }}
            onClick={initfunc}
          >
            Menu
          </button>
        )}
      </>
    );
  }

  if (DisplayOnCart) {
    return (
      <>
        <AlertDialog
          isLoading={false}
          open={isAlertOpen}
          setOpen={setAlertOpen}
          onAgree={onAlertAgree}
          onDisagree={onAlertDisagree}
          buttonAgreeLabel={buttonAgreeLabel}
          buttonDisagreeLabel='Cancel'
          displayText=''
          showAgreeButton={false}
          showDisagreeButton={showDisagreeButton}
        >
          {/* <PromoProductCard PromoVerbage={PromoVerbage} /> */}
        </AlertDialog>

        {/* {!CheckUrlCheckoutOrder && <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    borderBottomLeftRadius: '5px',
                    border: "1px solid black",
                    padding: "10px",
                    borderRadius: "5px",
                    background: "#fffbe9",
                    margin: "10px 0px 10px 0px",
                    fontFamily: 'Roboto Regular',
                    fontSize: '12px',
                    letterSpacing: '0.5px',

                }}>

                    {PromoVerbage()}

                    <button
                        style={{
                            marginLeft: '10px',
                            fontFamily: 'Roboto Regular',
                            letterSpacing: '0.5px',
                            fontSize: '12px',
                            width: '100px',
                            height: '20px',
                            marginTop: '10px',
                            border: '1px solid rgb(212, 215, 225)',
                            borderRadius: '3px'

                        }}
                        onClick={initfunc}>
                        Menu
                    </button>
                </div>} */}
      </>
    );
  }

  return (
    <>
      <AlertDialog
        isLoading={false}
        open={isAlertOpen}
        setOpen={setAlertOpen}
        onAgree={onAlertAgree}
        onDisagree={onAlertDisagree}
        buttonAgreeLabel={buttonAgreeLabel}
        buttonDisagreeLabel='Cancel'
        displayText=''
        showAgreeButton={false}
        showDisagreeButton={showDisagreeButton}
      >
        {/* <PromoProductCard PromoVerbage={PromoVerbage} /> */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            margin: '10px 10px 20px 10px',
            border: 'rgb(149, 237, 135)',
            backgroundColor: 'rgb(149, 237, 135)',
            height: isMobile ? '50px' : '70px',
            alignContent: 'center',
            justifyContent: 'center',
            padding: '10px',
            borderRadius: '5px',
            color: 'rgb(0, 49, 92)',
            fontFamily: 'Roboto Medium',
            fontSize: isMobile ? '13px' : '16px',
            textAlign: 'center',
          }}
        >
          {PromoVerbage()}
        </div>
        <VerticalAlwaysOpenStepper />
      </AlertDialog>

      {!CheckUrlCheckoutOrder && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            height: '35px',
            marginLeft: '10px',
            backgroundColor: '#feecbe',
            borderBottomLeftRadius: '5px',
            color: '#3C3B3D',
            fontFamily: 'Roboto Regular',
            letterSpacing: '0.5px',
            fontSize: '14px',
          }}
        >
          {PromoVerbage()}
          <button
            style={{
              marginLeft: '10px',
              fontFamily: 'Roboto Regular',
              letterSpacing: '0.5px',
              fontSize: '12px',
              width: '100px',
            }}
            onClick={initfunc}
          >
            Menu
          </button>
        </div>
      )}

      {CheckUrlCheckoutOrder && (
        <button
          style={{
            marginLeft: '10px',
            fontFamily: 'Roboto Medium',
            letterSpacing: '0.5px',
            fontSize: '12px',
            border: '0.5px solid rgb(24, 20, 54)',
            borderRadius: '3px',
            color: 'white',
            background: 'rgb(24, 20, 54)',
            height: '25px',
            width: '70px',
          }}
          onClick={initfunc}
        >
          Menu
        </button>
      )}
    </>
  );
};

export default PromotionalKitchenMenu;
